import { createOperacao, getOperacao, updateOperacao } from "@spark/services/operacoes";
import React, { useMemo, useCallback, useState, useEffect } from 'react';
import { Form } from 'react-final-form';
import { useHistory, useParams } from 'react-router-dom';
import { Button, ButtonWithLoading } from '@spark/ui-components/components/Button';
import { Card, CardBody } from '@spark/ui-components/components/Card';
import { FormButtonToolbar, FormContainer } from '@spark/ui-components/components/form/FormElements';
import { formStructure, formSections, validateForm } from './formConfig';
import DynamicForm from '@spark/ui-components/components/form/DynamicForm';
import { notification } from '@spark/ui-components/utils/notification';
import { updateMultipleFieldsByName } from '@spark/ui-components/utils/formHelpers'; // Função para buscar opções de situação

const searchSituacaoOptions = async searchTerm => {
  const options = [{
    value: 'Ativo',
    label: 'Ativo'
  }, {
    value: 'Inativo',
    label: 'Inativo'
  }];

  if (!searchTerm) {
    return options;
  }

  return options.filter(option => option.label.toLowerCase().includes(searchTerm.toLowerCase()));
};

const mapFormToCreateApi = values => {
  return {
    NomeOperacao: values.nomeOperacao,
    TipoDaOperacao: values.tipoDaOperacao,
    Situacao: values.situacao?.value || values.situacao || 'Ativo',
    DiasRecorrencia: values.diasRecorrencia ? parseInt(values.diasRecorrencia) : null,
    RecorrenciaLigada: values.recorrenciaLigada || false,
    ValorIndividualPallet: values.valorIndividualPallet || '0',
    ValorEtiquetas: values.valorEtiquetas || '0',
    ValorArmazenagem: values.valorArmazenagem || '0',
    Freetime: values.freetime ? parseInt(values.freetime) : '0',
    Observacao: values.observacao || '',
    GerarCobranca: values.gerarCobranca || false
  };
};

const Forms = ({
  isReadOnly = false,
  disabled = false
}) => {
  const history = useHistory();
  const {
    id
  } = useParams();
  const [loading, setLoading] = useState(false);
  const [initialData, setInitialData] = useState(null);
  const [loadingData, setLoadingData] = useState(false);
  const isEditMode = !!id; // Carregar dados quando for modo de edição ou visualização

  useEffect(() => {
    if ((isEditMode || isReadOnly) && id) {
      const loadData = async () => {
        try {
          setLoadingData(true);
          const data = await getOperacao(id);
          setInitialData({
            nomeOperacao: data.NomeOperacao || '',
            tipoDaOperacao: data.TipoDaOperacao || '',
            situacao: data.Situacao ? {
              value: data.Situacao,
              label: data.Situacao
            } : {
              value: 'Ativo',
              label: 'Ativo'
            },
            diasRecorrencia: data.DiasRecorrencia?.toString() || '',
            recorrenciaLigada: data.RecorrenciaLigada || false,
            valorIndividualPallet: data.ValorIndividualPallet || '',
            valorEtiquetas: data.ValorEtiquetas || '',
            valorArmazenagem: data.ValorArmazenagem || '',
            freetime: data.Freetime || '',
            observacao: data.Observacao || '',
            gerarCobranca: data.GerarCobranca || false
          });
        } catch (error) {
          console.error('Erro ao carregar operação:', error); // Erro tratado automaticamente pelo interceptor global do axios
        } finally {
          setLoadingData(false);
        }
      };

      loadData();
    }
  }, [isEditMode, isReadOnly, id]);
  const onSubmit = useCallback(async values => {
    try {
      setLoading(true);
      const payload = mapFormToCreateApi(values);

      if (isEditMode) {
        await updateOperacao(id, payload);
        notification.success('Operação atualizada com sucesso!');
        history.goBack(); // Volta para a tela anterior após editar
      } else {
        await createOperacao(payload);
        notification.success('Operação criada com sucesso!');
        history.goBack();
      }
    } catch (err) {// Erro tratado automaticamente pelo interceptor global do axios
    } finally {
      setLoading(false);
    }
  }, [history, id, isEditMode]);
  const defaultValues = useMemo(() => ({
    nomeOperacao: '',
    tipoDaOperacao: '',
    situacao: {
      value: 'Ativo',
      label: 'Ativo'
    },
    diasRecorrencia: '',
    recorrenciaLigada: false,
    valorIndividualPallet: '',
    valorEtiquetas: '',
    valorArmazenagem: '',
    freetime: '',
    observacao: '',
    gerarCobranca: false
  }), []);
  const initialValues = initialData || defaultValues; // Atualiza a estrutura do formulário com as funções de busca

  const updatedFormStructure = useMemo(() => {
    const fieldUpdates = {
      situacao: {
        onSearch: searchSituacaoOptions
      }
    };
    return updateMultipleFieldsByName(formStructure, fieldUpdates);
  }, []);

  if ((isEditMode || isReadOnly) && loadingData) {
    return <Card>
        <CardBody>
          <div style={{
          textAlign: 'center',
          padding: '50px'
        }}>
            Carregando dados da operação...
          </div>
        </CardBody>
      </Card>;
  }

  return <Form onSubmit={onSubmit} initialValues={initialValues} validate={validateForm}>
      {({
      handleSubmit,
      form: {
        reset
      },
      values
    }) => {
      console.log('📝 Valores atuais do formulário (Cadastro):', values);
      return <Card>
          <CardBody>
            <FormContainer onSubmit={handleSubmit}>
              <DynamicForm structure={updatedFormStructure} sections={formSections(initialValues)} isViewMode={disabled} />
                
              {!isReadOnly && !disabled && <FormButtonToolbar className="mt-5">
                  <ButtonWithLoading variant="primary" type="submit" loading={loading ? 'true' : undefined}>
                    
                    {isEditMode ? 'Atualizar' : 'Salvar'}
                  </ButtonWithLoading>
                  <Button variant="secondary" type="button" onClick={() => isEditMode ? history.goBack() : history.goBack()}>
                    
                    Cancelar
                  </Button>
                </FormButtonToolbar>}
                
            </FormContainer>
          </CardBody>
        </Card>;
    }}
    </Form>;
};

export default Forms;
